import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99992 14.8003H11.9999V5.46696H3.99992V14.8003ZM12.6666 3.46696H10.3333L9.66659 2.80029H6.33325L5.66659 3.46696H3.33325V4.80029H12.6666V3.46696Z"
        fill={fill}
      />
    </svg>
  );
};

export default memo(Icon);
